import { useLocation, useOutletContext } from "react-router-dom";
import PageTitle from "@/components/PageTitle";
import { JobsOutletContext } from "@/pages/_layouts/jobs/JobPostIndexLayout";
import JobDetailsSkeleton from "@/pages/_layouts/jobs/_components/JobDetailsSkeleton";
import ViewJobPostReviews from "@/pages/_layouts/jobs/_components/ViewJobPostReviews";

export default function JobPostReviews() {
  const location = useLocation();
  const { data, loading, title } = useOutletContext<JobsOutletContext>();

  if (loading) {
    <JobDetailsSkeleton />;
  }

  if (!data?.jobPost) return null;

  return (
    <>
      <PageTitle pattern={location.pathname} title={`${title} | Jobs | Job Post Reviews`} />
      <ViewJobPostReviews jobPost={data.jobPost} />
    </>
  );
}
